import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';
import{erpplatserver} from '@/utils/baseUrl';
// import {newfile_url} from "../../utils/baseUrl";

///费用
//保存能耗列表
export async function saveNh(params) {
    return post(erpserver+'/statistics/saveNh', params, true);
}

//获取能耗xiangqi
export async function getNhDetails(params) {
    return post(erpserver+'/statistics/getNhDetails', params, true);
}

//获取能耗列表
export async function getNhList(params) {
    return post(erpserver+'/statistics/getNhList', params, true);
}

//获取费用列表
export async function getStatisticsXhList(params) {
    return post(erpserver+'/statistics/getStatisticsXhList', params, true);
}

//保存费用列表里单价等
export async function saveStatisticsXh(params) {
    return post(erpserver+'/statistics/saveStatisticsXh', params, true);
}

//提交费用列表里单价等
export async function sendStatisticsMsg(params) {
    return post(erpserver+'/statistics/sendStatisticsMsg', params, true);
}

/////
//审核
export async function flowSub(params) {
    return post(erpplatserver+'/flow/flowSub', params, true);
}

//结算单列表
export async function getStatisticsList(params) {
    return post(erpserver+'/statistics/getStatisticsList', params, true);
}

//生成结算/更改前保存
export async function saveStatistics(params) {
    return post(erpserver+'/statistics/saveStatistics', params, true);
}

//保存结算单列表
export async function updStatistics(params) {
    return post(erpserver+'/statistics/updStatistics', params, true);
}

/*//上传附件
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile', params, true);
}*/

//上传图片
export async function upload(params) {
    return post(erpplatserver+'/system/uploadFile',params,false);
}

//报表数据
export async function loadDataFromSvr(params) {
    return post(erpplatserver+'/reportForm/getFormJsonData', params, true);
}

//报表模板
export async function download(params) {
    return post(erpplatserver+'/reportForm/download', params, true);
}

